module.exports = __webpack_public_path__ + "img/male_A_02.1d512bc9.png";